type Props = {}

const Profile = (props: Props) => {
  return (
    <div>Perfil de usuario</div>
  )
}

export default Profile